module.exports = __webpack_public_path__ + "img/190-uzbekistn.aa7991f6.svg";